function RevealSEOText( elemet )
{
    var parent      = elemet.parentNode;
    var container   = parent.querySelector( ".bridgman-page-seo-text-container" );
    var inner       = parent.querySelector( ".bridgman-page-seo-text-container-inner" );
    var chevron     = parent.querySelector( ".bridgman-seo-chevron-container" );

    if( container.offsetHeight == 0 )
    {
        container.style.height      = inner.offsetHeight + "px";
        chevron.style.transform     = "translate(-50%, -50%) rotate( 180deg )";
    }
    else
    {
        container.style.height = 0 + "px";
        chevron.style.transform    = "translate(-50%, -50%) rotate( 360deg )";
    }
}

window.addEventListener( "DOMContentLoaded", function()
{
    var container   = document.querySelector( ".bridgman-page-seo-text-container" );
    var inner       = container.querySelector( ".bridgman-page-seo-text-container-inner" );

    container.setAttribute( "style", "height: " + inner.offsetHeight + "px;" );
} );